import styled from "styled-components";

export const DontainerDetail =styled.div`
  background: #0f0e17;
` 
export const DetailDiv = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding-top: 3rem;
  color: white;

`
 export const ImgBack = styled.img`
 `